import SiteFooter from "../SiteFooter";

export default function DesktopFooter({ isHomePage = false }) {
	return <SiteFooter isHomePage={isHomePage} />;
}
